import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The fabled, but lazy, day",
  "description": "",
  "published": "2008-07-30T00:00:00.000Z",
  "redirect_from": ["/blog/the-fabled-but-lazy-day/swizec/88"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was the fabled second day after a blog post, which meant I should've written a new blog post as I once, long ago, promised I would. Obviously since then I haven't quite lived up to my promise, but I try to post as much as humanly possible.`}</p>
    <p>{`That is to say, I try to try as much as humanly possible because in all factuality I'm simply quite too lazy to keep posting all the time and there are always things coming up and biting me in the arse with, apparently, the sole intention of distracting me from writing the blog even when I have awesome ideas.`}</p>
    <p>{`But that is not all, a while ago I vowed to have the site updated to a new design and made all pretty and such by the end of the month, which is tomorrow, and it doesn't quite look like I'm going to make it. Even though the coding `}<em parentName="p">{`is`}</em>{` rather much all done because I skillfully integrated it into a project at work and opensource demands I get to use it elsewhere as well, there's this little issue of design. The designs I haven't touched since sketching up the fancy bits five days ago. The design that doesn't seem to be getting made for a while.`}</p>
    <p>{`Although I really should, absolutely must, kick myself into high gear and draw those fucking things already and throw it all together. Must. Why? So I can work on other more lucrative projects I've recently hooked up with. Let's hope money will be enough to throw laziness to the wind and let me work.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      